export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/white-next.88e0c862.svg","height":13,"width":14,"blurWidth":0,"blurHeight":0};